import { GQL } from 'src/graphql';
import { AdapterFunc } from 'src/hooks/useEntityAdapter';
import { CallPatternModel } from 'src/models';

const callPatternAdapter: AdapterFunc<GQL.CallPatternModel, CallPatternModel> = (input) => ({
  id: input.id,
  name: input.name!,
  description: input.description!,
  createdAt: input.createdAt,
  updatedAt: input.updatedAt,
});

export default callPatternAdapter;
